export enum TourSorting {
  POPULARITY = 'Popularity',
  PRICE_ASC = 'PriceAsc',
  PRICE_DESC = 'PriceDesc',
  DATE_ASC = 'DateAsc',
  DATE_DESC = 'DateDesc',
}
